export default "__VITE_ASSET__BDW$to_Z__"